/**
 * Crossfade slideshow for the homepage header circle: the next image fades in
 * over the current one (no brightness dip), then the previous one is released.
 */
export default (options = {}) => ({
  interval: options.interval ?? 4000,
  fade: options.fade ?? 700,
  index: 0,
  timer: null,
  cleanupTimer: null,
  slides: [],

  init() {
    this.slides = [...this.$el.querySelectorAll('img')];
    this.$el.style.setProperty('--fade', `${this.fade}ms`);
    if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    document.addEventListener('visibilitychange', () => {
      document.hidden ? this.stop() : this.start();
    });
    this.start();
  },

  start() {
    this.stop();
    this.timer = setInterval(() => this.next(), this.interval);
  },

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  },

  next() {
    this.show((this.index + 1) % this.slides.length);
  },

  show(i) {
    const prev = this.index;
    this.index = i;
    this.slides.forEach((slide, n) => {
      slide.classList.remove('is-prev');
      if (n === prev && n !== i) {
        slide.classList.add('is-prev');
      }
      slide.classList.toggle('is-on', n === i);
    });
    clearTimeout(this.cleanupTimer);
    const prevSlide = this.slides[prev];
    if (!prevSlide || prev === i) {
      return;
    }
    // Once the incoming slide has fully faded in, drop the outgoing one
    // immediately instead of running a second (slower) fade-out — that
    // second fade is what left it lingering behind non-covering slides.
    this.cleanupTimer = setTimeout(() => {
      prevSlide.style.transition = 'none';
      prevSlide.classList.remove('is-prev');
      void prevSlide.offsetWidth;
      prevSlide.style.transition = '';
    }, this.fade);
  },
});
